import { ChangeEvent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Language, LANGUAGES } from "../../Language";
import { LS_SESSION_LANG_KEY, LS_LANG_KEY } from "constants/constants";

const LanguageSelector = () => {
    const { t, i18n } = useTranslation();
    const defaultLanguage: string = Language.EN;

    useEffect(() => {
        const initLang = () => {
            const langInCache = localStorage.getItem(LS_LANG_KEY);
            if (langInCache) {
                return;
            }

            if (updateLang(navigator.language.split("-")[0])) {
                return;
            }

            if (updateLang(localStorage.getItem(LS_SESSION_LANG_KEY))) {
                return;
            }

            updateLang(defaultLanguage);
        };

        initLang();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const normalizeLangKey = (lang: string) =>
        lang.toUpperCase() as keyof typeof Language;

    const updateLang = (lang: string | null | undefined): boolean => {
        if (!lang) {
            return false;
        }

        const newLang = Language[normalizeLangKey(lang)];
        if (!newLang) {
            return false;
        }

        i18n.changeLanguage(newLang);
        localStorage.setItem(LS_LANG_KEY, newLang);
        return true;
    };

    return (
        <div>
            <div>
                <select
                    name="language"
                    value={i18n.language}
                    onChange={(event: ChangeEvent<HTMLSelectElement>) => {
                        updateLang(event.target.value.toLocaleUpperCase());
                    }}
                    aria-label={t("language")}
                >
                    {LANGUAGES.map((language) => (
                        <option
                            key={language.key}
                            value={language.key}
                            lang={language.descriptionLanguage}
                        >
                            {language.description}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default LanguageSelector;
